<template>
  <div class="login-or-pay-modal">
    <div v-if="getDataStatus">
      <DredgeVipDefault v-if="user.userLevel" v-bind="$attrs"></DredgeVipDefault>
      <LoginModule v-else></LoginModule>
    </div>
  </div>
</template>

<script>
  import LoginModule from './LoginModule'
  export default {
    components: {
      LoginModule,
    },
    data() {
      return {
        user: {},
        getDataStatus: false
      }
    },
    mounted () {
      this.query()
    },
    methods: {
      query() {
        this.$store.dispatch('getUserInfo')
        .then(res=>{
          this.getDataStatus = true
          this.user = res.userLevel?res:{}
        })
        .catch(err=>{
          this.getDataStatus = true
        })
      },
    },
  }
</script>